import { Alert } from '@root/components'
import { getSettingsPageUrl } from '@root/constants'
import { useBusinessContext } from '@root/context'
import { VatPeriodAuthorizationResponse } from '@root/query'

import React from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

interface Props {
  authData: VatPeriodAuthorizationResponse
  hasGeneralError?: boolean
}

const VatAuhtorization: React.FC<Props> = ({ authData, hasGeneralError = false }) => {
  const [t] = useTranslation()
  const { slug } = useBusinessContext()

  const description = (
    <InfoBody>
      <p>{authData?.message?.body}</p>
      {authData?.link && (
        <Trans
          i18nKey="vatPage.authorization.infoInvalid"
          components={[
            <a key="0" target="_blank" rel="noreferrer" href={authData?.link} />,
            <Link key="1" to={getSettingsPageUrl(slug, { page: 'verohallinto' })} />
          ]}
        />
      )}
    </InfoBody>
  )

  if (hasGeneralError) {
    return (
      <Alert
        type="error"
        title={t('vatPage.authorization.errorTitle')}
        description={t('vatPage.authorization.errorDescription')}
      />
    )
  }

  return (
    <Alert
      type={authData.ok ? 'success' : 'error'}
      title={authData?.message?.header}
      description={description}
    />
  )
}

export default VatAuhtorization

const InfoBody = styled.div`
  p {
    margin-bottom: ${({ theme }) => theme.spacing.xxxs}rem;
  }
`
